import { getCookie } from './plugins/userUtils';

export const configureFetchMs = (method, body = null, get_cookie = true) => {
  let headers = {
    'Content-Type': 'application/json',
  };
  const tokenDom = document.querySelector('meta[name=csrf-token]');
  if (tokenDom) {
    const csrfToken = tokenDom.content;
    headers['X-CSRF-Token'] = csrfToken;
  }
  headers['X-CAuth'] = '1@AS';

  if (get_cookie) {
    const buIds = window.config.business_unit.path_ids_of_current_bu_structures;
    const ancestorBuIds = buIds.slice(0, buIds.indexOf(window.config.business_unit.id) + 1);

    (headers['X-EPERSONAM-BU-ID'] = `${window.config.business_unit.id}`),
      (headers['X-ANCESTOR-BU-IDS'] = ancestorBuIds),
      (headers['Authorization'] = `Bearer ${getCookie('jwt')}`);
  }

  let response = {
    method,
    mode: 'cors',
    cache: 'default',
    credentials: 'include',
    headers,
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  if (body) {
    response = {
      ...response,
      body,
    };
  }

  return response;
};
